module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product product-content-component",
    style: (_vm.product.boxStyles)
  }, [_c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-content-detail-left product-content-detail",
    class: [_vm.product.orientation == 'right' ? 'hidden-element' : '']
  }, [_c('ProductDetails', {
    attrs: {
      "product": _vm.product
    }
  })], 1), _vm._v(" "), (_vm.product.device) ? _c('div', {
    staticClass: "product-content-device",
    class: [_vm.product.device.color == 'white-device' ? 'white-device' : '', _vm.product.device.color == 'gray-device' ? 'gray-device' : '', _vm.product.device.color == 'black-device' ? 'black-device' : ''],
    style: ({
      transform: 'rotate(' + _vm.product.device.rotation + ')'
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.product.device.image,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product.name == 'Measure') ? _c('div', {
    staticClass: "product-content-measure"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/measure-screenshot.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-content-detail-right product-content-detail",
    class: [_vm.product.orientation == 'left' ? 'hidden-element' : '']
  }, [_c('ProductDetails', {
    attrs: {
      "product": _vm.product
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b4f0463"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/products/ProductComponent.vue
// module id = 452
// module chunks = 0